export default __webpack_public_path__ + "static/media/rbl_logo.2bc7cfb8.jpg";